import React, { FC } from 'react';
import { styled } from '@mui/system';

type ToothProps = {
    number: number;
    path: string;
    textPosition: string;
    selectedTeeth: number[];
    hoveredTeeth: number[];
    selectedTeethState: Map<number, number>;
    isPonticExtracted?: boolean;
};

const Tooth: FC<ToothProps> = ({
    number,
    path,
    textPosition,
    selectedTeeth,
    hoveredTeeth,
    selectedTeethState,
    isPonticExtracted,
}) => {
    const state = selectedTeethState.get(number);
    const showNumber = !isPonticExtracted || [undefined, 0, 1, 4].includes(state);
    const showP = isPonticExtracted && state === 2;
    const showE = isPonticExtracted && state === 3;

    const ToothWrapper = styled('g')<{ selected: boolean; hovered: boolean }>(({ theme, selected, hovered }) => ({
        cursor: 'pointer',
        '& path': {
            fill: selected ? theme.palette.secondary.main : hovered ? theme.palette.secondary.light : '#eee',
            stroke: selected || hovered ? '#999' : '#ccc',
            opacity: hovered && !selected ? 0.7 : 1,
        },
        '& text': {
            fontSize: 20,
            fontWeight: 'bold',
            fill: selected || hovered ? '#fff' : '#000',
            pointerEvents: 'none', // Make text non-clickable
        },
    }));

    return (
        <ToothWrapper
            data-tooth={number}
            data-test={`teeth-selection.tooth-${number}`}
            selected={selectedTeeth.includes(number)}
            hovered={hoveredTeeth.includes(number)}
            className={isPonticExtracted && state ? `tState-${state}` : ''}
        >
            <path d={path} transform="translate(-38.187 -35.477)" />
            {showNumber && (
                <text
                    textAnchor="middle"
                    fontSize="19"
                    fontWeight="bold"
                    fill="#000"
                    transform={`translate(${textPosition})`}
                >
                    {number}
                </text>
            )}
            {showP && (
                <text
                    textAnchor="middle"
                    fontSize="19"
                    fontWeight="bold"
                    fill="#000"
                    transform={`translate(${textPosition})`}
                >
                    P
                </text>
            )}
            {showE && (
                <text
                    textAnchor="middle"
                    fontSize="19"
                    fontWeight="bold"
                    fill="#000"
                    transform={`translate(${textPosition})`}
                >
                    E
                </text>
            )}
        </ToothWrapper>
    );
};

export default Tooth;
